<template>
  <div class="main-wrapper">
    <headerthree></headerthree>
    <div class="container">
      <layout-sidebar></layout-sidebar>

      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <div class="content container-fluid">
          <indexpage></indexpage>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>
